module.exports = __webpack_public_path__ + "img/ecuador.6a434f5c.svg";